/**
 * SIM-1502 — read-only display of the Dottie system prompt, the static export
 * `DATA_ASSISTANT_SYSTEM_PROMPT` from `@simplicity/agents`. There is intentionally no edit
 * affordance: the prompt is source-controlled and changed only by a PR, so the button is a GitHub
 * deep-link to its source file rather than a `mailto:` (SIM-1680 E).
 */
import { DATA_ASSISTANT_SYSTEM_PROMPT } from "@simplicity/agents/dataAssistantPrompt";
import { Button } from "@simplicity/ui";

const EDIT_HREF =
  "https://github.com/Simplicity-Education/simplicity/blob/main/packages/agents/src/dataAssistantPrompt.ts";

export function SystemPromptView() {
  return (
    <section aria-labelledby="universal-system-prompt-heading" className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 id="universal-system-prompt-heading" className="text-lg font-semibold text-foreground">
          System prompt
        </h3>
        <Button asChild variant="outline" size="sm">
          <a href={EDIT_HREF} target="_blank" rel="noopener noreferrer">
            Edit via PR
          </a>
        </Button>
      </div>
      <p className="text-sm text-muted-foreground">
        Read-only. The system prompt is source-controlled in
        <code className="mx-1 rounded bg-muted px-1 py-0.5 text-xs">@simplicity/agents</code>
        and changed only through a PR review.
      </p>
      <pre
        data-testid="universal-system-prompt"
        className="max-h-96 overflow-auto rounded-md border border-border bg-muted/30 p-3 font-mono text-xs whitespace-pre-wrap text-foreground"
      >
        {DATA_ASSISTANT_SYSTEM_PROMPT}
      </pre>
    </section>
  );
}
